import React, { useState } from "react";
import s1 from "../media3/spotlight/s1.png";
import bg1 from "../media3/spotlight/bg1.png";
import s2 from "../media3/spotlight/s2.png";
import s3 from "../media3/spotlight/s3.jpg";
import s4 from "../media3/spotlight/s4.svg";
import s5 from "../media3/spotlight/s5.jpg";
import s6 from "../media3/spotlight/s6.png";
import s7 from "../media3/spotlight/s7.png";
import s8 from "../media3/spotlight/s8.jpg";
import s9 from "../media3/spotlight/s9.png";
import s10 from "../media3/spotlight/s10.png";
import s11 from "../media3/spotlight/s11.png";
import s12 from "../media3/spotlight/s12.png";
import s13 from "../media3/spotlight/s13.png";
import s14 from "../media3/spotlight/s14.png";
import s15 from "../media3/spotlight/s15.png";

const players = [
 {
  name: "John Onyx",
  role: "Professional illustrator playing with photomontage",
  artworks: 110,
  battleWins: 987,
  earnings: 221,
  img: s1,
  rating: 5,
  review:
    "Amazing collaboration — the skin textures and color grading were top-tier. Fast delivery and excellent communication.",
},
{
  name: "Michelle Cortez",
  role: "I create different projects with illustrations",
  artworks: 140,
  battleWins: 445,
  earnings: 449,
  img: s2,
  rating: 4,
  review:
    "Great eye for detail, really helped refine the concept art into production-ready assets. Highly recommended.",
},
{
  name: "Alexandra Smith",
  role: "I am a professional digital art creator",
  artworks: 220,
  battleWins: 1125,
  earnings: 150,
  img: s4,
  rating: 5,
  review:
    "Exceptional realism and polish. The final models exceeded expectations and performance was smooth in-game.",
},
{
  name: "Ryan Slate",
  role: "Marketing expert and NFT creator",
  artworks: 90,
  battleWins: 321,
  earnings: 78,
  img: s3,
  rating: 4,
  review:
    "Strong creative direction and solid execution. Would like slightly faster turnaround next time.",
},
{
  name: "Alexa Brains",
  role: "Specialized in creating monkey NFTs",
  artworks: 75,
  battleWins: 127,
  earnings: 47,
  img: s5,
  rating: 3,
  review:
    "Fun concepts and unique style, but needed a couple of revision rounds to match the brief.",
},
{
  name: "Ethan Vale",
  role: "Concept artist blending sci-fi and realism",
  artworks: 185,
  battleWins: 854,
  earnings: 199,
  img: s6,
  rating: 5,
  review:
    "Brilliant synthesis of sci-fi elements and functional design — seen great player feedback on these skins.",
},
{
  name: "Nora Quinn",
  role: "Fantasy character designer and digital painter",
  artworks: 132,
  battleWins: 677,
  earnings: 305,
  img: s7,
  rating: 4,
  review:
    "Beautiful color palettes and consistent style. Minor export issues, but overall a very positive outcome.",
},
{
  name: "Liam Frost",
  role: "3D artist creating hyperrealistic weapon models",
  artworks: 160,
  battleWins: 1220,
  earnings: 414,
  img: s8,
  rating: 5,
  review:
    "Top notch 3D work — LODs and UVs were perfect and optimized for performance.",
},
{
  name: "Chloe Winters",
  role: "Visual storyteller passionate about gaming worlds",
  artworks: 145,
  battleWins: 910,
  earnings: 288,
  img: s9,
  rating: 4,
  review:
    "Excellent narrative-driven designs that translated well to in-game storytelling.",
},
{
  name: "Dylan Knox",
  role: "Skin designer for FPS games and creative director",
  artworks: 208,
  battleWins: 1325,
  earnings: 340,
  img: s10,
  rating: 5,
  review:
    "Creative leadership and high-quality assets — a pleasure to work with on multiple drops.",
},
{
  name: "Ivy Morales",
  role: "Digital illustrator exploring cyberpunk aesthetics",
  artworks: 174,
  battleWins: 789,
  earnings: 256,
  img: s11,
  rating: 4,
  review:
    "Stylish cyberpunk motifs and excellent shader work. Would collaborate again.",
},
{
  name: "Mason Cole",
  role: "Minimalist game artist and NFT innovator",
  artworks: 92,
  battleWins: 605,
  earnings: 145,
  img: s12,
  rating: 3,
  review:
    "Clean minimalist approach, but needed additional iteration for variety.",
},
{
  name: "Sophie Lin",
  role: "Digital concept artist focused on character design",
  artworks: 210,
  battleWins: 1420,
  earnings: 322,
  img: s13,
  rating: 5,
  review:
    "Consistently excellent character work and styling. Fast and professional.",
},
{
  name: "Noah Reyes",
  role: "3D sculptor and animation specialist for eSports titles",
  artworks: 187,
  battleWins: 999,
  earnings: 203,
  img: s14,
  rating: 4,
  review:
    "Great sculpting and animation polish; small tweaks required for rigging.",
},
{
  name: "Aria Blake",
  role: "Virtual environment designer crafting immersive skins",
  artworks: 134,
  battleWins: 870,
  earnings: 268,
  img: s15,
  rating: 5,
  review:
    "Immersive environments translated into skins beautifully — excellent depth and detail.",
},

];

function Spotlight() {
  const [activeIndex, setActiveIndex] = useState(2); // Start with the middle card active

  // Helper function to handle circular next/prev clicks
  const handleNext = () => {
    setActiveIndex((prevIndex) => (prevIndex + 1) % players.length);
  };

  const handlePrev = () => {
    setActiveIndex((prevIndex) =>
      (prevIndex - 1 + players.length) % players.length
    );
  };

  // helper to render star rating
  const renderStars = (rating) => {
    const total = 5;
    return (
      <div className="star-row" aria-hidden="true">
        {Array.from({ length: total }).map((_, i) => (
            <span
          key={i}
          className={`star ${i < rating ? "filled" : "empty"}`}
          style={{
            display: "inline-flex",
            marginRight: 4,
          }}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                height="16px"
                viewBox="0 -960 960 960"
                width="16px"
                fill={i < rating ? "#FFD166" : "rgba(255,255,255,0.12)"}
              >
                <path d="m354-287 126-76 126 77-33-144 111-96-146-13-58-136-58 135-146 13 111 97-33 143ZM233-120l65-281L80-590l288-25 112-265 112 265 288 25-218 189 65 281-247-149-247 149Zm247-350Z" />
              </svg>
            </span>
                  ))}
                  <span className="sr-only" style={{ position: "absolute", left: -9999 }}>
                    Rated {rating} out of 5
                  </span>
                </div>
              );
            };

  return (
    <div className="spotlight-section">
      <span className="section-decorative-bar">What Our Players Say</span>
      <h1 className="spotlight-title">Players Spotlight</h1>
       <p className="spotlight-subtitle">
        Discover the creators, competitors, and influencers shaping the world of gaming skins — all in one place.
      </p>
      <div className="spotlight-container">
        {players.map((player, index) => {
          let position = index - activeIndex;
          if (position < -Math.floor(players.length / 2)) {
            position += players.length;
          }
          if (position > Math.floor(players.length / 2)) {
            position -= players.length;
          }

          const absPosition = Math.abs(position);
          const isVisible = absPosition <= 2; 

          return (
            <div
              key={index}
              className={`spotlight-card ${
                index === activeIndex ? "active" : ""
              } ${!isVisible ? "hidden" : ""}`}
              style={{
                "--pos": position,
                "--absPos": absPosition,
              }}
              onClick={() => {
                if (index === activeIndex + 1 || (activeIndex === players.length - 1 && index === 0)) {
                  handleNext();
                } else if (index === activeIndex - 1 || (activeIndex === 0 && index === players.length - 1)) {
                  handlePrev();
                } else {
                  setActiveIndex(index);
                }
              }}
            >
              <div className="background-wrapper">
                <img src={bg1} alt="background" className="bg-image" />
                <img src={player.img} alt={player.name} className="player-img" />
              </div>

              <div className="player-name">
                <h3>{player.name}</h3>
              </div>

              <p className="role">{player.role}</p>

              {/* rating stars */}
              <div className="rating-block" style={{ marginTop: 8 }}>
                {renderStars(player.rating)}
              </div>

              {/* review snippet */}
              <div className="player-review" style={{ marginTop: 10, color: "rgba(255,255,255,0.85)", fontSize: 13, lineHeight: "1.3em" }}>
                {player.review.length > 120 ? player.review.slice(0, 120) + "…" : player.review}
              </div>

              {/* <div className="buttons" style={{ marginTop: 12 }}>
                <button className="follow-btn">Follow</button>
                <button className="msg-btn">Message</button>
              </div> */}

              <div className="stats" style={{ marginTop: 12 }}>
                <span>Skins Buy {player.artworks}</span>
                <span>Battle Wins {player.battleWins}</span>
                <span>Earnings ${player.earnings}</span>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}

export default Spotlight;
